var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubspot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4495_1084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5967 7.89918V5.04103C18.3672 4.68089 18.8614 3.90856 18.8666 3.05791V2.99179C18.8666 1.77491 17.8795 0.788277 16.6626 0.788277H16.5984C15.3815 0.788277 14.3948 1.77491 14.3948 2.99179V3.05791C14.398 3.47588 14.52 3.88432 14.7466 4.23555C14.9732 4.58678 15.2951 4.86631 15.6746 5.0415V7.89918C14.5899 8.06471 13.5653 8.51723 12.7114 9.20469L4.87128 3.10246C4.92708 2.90129 4.95709 2.69308 4.95991 2.48488V2.47972C4.95991 1.11043 3.84947 0 2.47972 0C1.11043 0 0 1.11043 0 2.47972C0 3.84807 1.10856 4.95803 2.47644 4.95991C2.90645 4.95615 3.32802 4.83845 3.69848 4.62087L11.4181 10.6265C10.7407 11.6503 10.3794 12.8507 10.3789 14.0783C10.3789 15.3627 10.7756 16.6185 11.5128 17.6694L9.1653 20.0169C8.97607 19.9608 8.77977 19.9322 8.58242 19.932C7.45885 19.932 6.54818 20.8427 6.54818 21.9658C6.54818 23.0893 7.45885 24 8.58242 24C9.70551 24 10.6162 23.0893 10.6162 21.9658V21.9597C10.6145 21.7606 10.5826 21.563 10.5215 21.3735L12.8436 19.0495C13.9395 19.8937 15.2839 20.3517 16.6673 20.3522C20.1261 20.3522 22.9308 17.5475 22.9308 14.0886C22.9308 10.9913 20.6659 8.35826 17.6033 7.8959L17.5967 7.89918ZM16.6406 17.2966C14.9154 17.2253 13.5526 15.8059 13.5526 14.0788C13.5526 12.4174 14.8174 11.0279 16.4708 10.8722H16.6406C18.3193 11.0002 19.6164 12.4 19.6164 14.0835C19.6164 15.7674 18.3193 17.1672 16.641 17.2947L16.6406 17.2966Z",
    fill: "#FF7A59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4495_1084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.9308,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspot);
export default __webpack_public_path__ + "static/media/hubspot.cd699c373725e586ed12b31d9ef921f2.svg";
export { ForwardRef as ReactComponent };